// File: components/FormikFileUpload.tsx
import React from "react";
import { useField, useFormikContext } from "formik";
import FileUpload from "../StyledComponents/StyledFileUpload";
import styled from "styled-components";
import { useToast } from "../toast/ToastContext";
import { useDocumnetPreSignedUrlMutation } from "../../api/contactApiSlice";
import { on } from "events";

interface UploadedFile {
    file: File;
    name: string;
    type: string;
    rename: string;
    progress: number;
}

interface FormikFileUploadProps {
    name: string;
    multiple?: boolean;
    accept?: string;
    icon?: React.ReactNode;
    showRenameInput?: boolean
    onUpload: (file: UploadedFile) => Promise<{ key: string }>; // Parent se aayega
    setHasUploaded: (state: boolean) => void;
    checkError?: string;
}

const FormikFileUpload: React.FC<FormikFileUploadProps> = ({
    name,
    multiple = false,
    accept = "*/*",
    icon,
    showRenameInput,
    onUpload,
    setHasUploaded,
    checkError
}) => {
    const [field, meta, helpers] = useField<UploadedFile[]>(name);
    const { setFieldValue } = useFormikContext();
    const showToast = useToast();
    const handleChange = async (files: UploadedFile[]) => {
        if (!multiple && files?.length > 1) {
            showToast("Upload Error", 'Only one file can be uploaded at a time.', "error");
            return;
        }

        const file = files[0];

        try {
            const { key } = await onUpload(file); // Parent ka function call
            setFieldValue(name, { file, key });
        } catch (error) {
            console.error('Error uploading file:', error);
            showToast("Could not upload file", 'File upload failed', "error");
        }
    };

    return (
        <>
            <FileUpload
                showRenameInput={showRenameInput}
                accept={accept} icon={icon}
                multiple={multiple}
                onChange={handleChange}
                removeFile={setHasUploaded}
            />
            {meta.touched && meta.error && (
                <ErrorText>{meta.error as string}</ErrorText>
            )}
            {checkError ? 
            <ErrorText>{checkError}</ErrorText> : null    
        }
        </>
    );
};

export default FormikFileUpload;

const ErrorText = styled.div`
  color: #d32f2f;
  font-size: 13px;
  margin-top: 6px;
`;
